<template>
  <section class="four-page-section media_section_height">
    <div class="media_screen_style" style="display: flex;flex-direction: column;align-items: center;">
      <div style="color: #fff6f6; font-size: 32px; margin-bottom: 16px" class="shake2">
        {{ t("four.title") }}
      </div>
      <div style="color: #fef8f8; font-size: 16px; margin-bottom: 32px; max-width: 450px;">
        {{ t("four.details") }}
      </div>
      <div class="four_img_bg">
        <FourBgImg>
          <div v-show="!hasAnimated" style="
              text-align: start;
              margin-left: 12px;
              font-size: 10px;
              font-weight: 200;
              margin-top: 27px;
            ">
            {{ t("four.titlethree") }}
          </div>
        </FourBgImg>
        <FourLang :class="['four_img_lang', isFading ? 'lang_animation' : '']" />
        <!-- 底部按钮 -->
        <Transition name="button_shrink_down">
          <div ref="fourContainer" v-show="!hasAnimated" class="four_bottom_button">
            {{ t("four.button") }}
          </div>
        </Transition>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref, onMounted } from "vue";
import FourBgImg from "./FourBgImg.vue";
import FourLang from "./FourLang.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const isFading = ref(false);

const hasAnimated = ref(false);
const fourContainer = ref(null);
onMounted(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && !hasAnimated.value) {
        setTimeout(() => {
          isFading.value = true;
          hasAnimated.value = true;
        }, 1500);
        observer.disconnect();
      }
    },
    {
      threshold: 0.5,
    }
  );

  if (fourContainer.value) {
    observer.observe(fourContainer.value);
  }
});
</script>

<style scoped>
.four_img_bg {
  position: relative;
  display: flex;
  justify-content: center;
  /* width: 300px;
    height: 666px; */
}

.four_img_bg_img {
  transition: opacity 2s ease;
}

.four_img_lang {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 0px;
  z-index: 100;
  width: 300px;
  /* position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 0px;
    width: 280px;
    height: 340px;
    background-color: #1D112D;
    z-index: 10;
    border-radius: 12px; */
  transition: transform 2s ease, width 2s ease, background-color 2s ease;
  /* opacity: 0; */
}

.four_img_lang_item {
  background: rgba(255, 255, 255, 0.1);
  /* 半透明背景 */
  backdrop-filter: blur(10px);
  /* 模糊背景 */
  -webkit-backdrop-filter: blur(10px);
  /* Safari 支持 */
  border-radius: 12px;
  padding: 20px;
  margin: 12px 6px;
}

.four-page-section {
  /* transform: scale(.7);
  transform-origin: top; */
  /* height: 100vh; */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 32px;
  /* min-height: 932px; */
}

/* 底部按钮 */
.four_bottom_button {
  color: #40fff9;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 18px;
  padding: 12px;
  z-index: 100;
  /* background-color: rgba(212, 134, 45, 0.596); */
  font-size: 14px;
  border-radius: 14px;
  width: 252px;
  left: 50%;
  transform: translate(-50%, 0%);
  background: rgba(255, 255, 255, 0.2);
  /* 半透明背景 */
  backdrop-filter: blur(10px);
  /* 毛玻璃模糊 */
  -webkit-backdrop-filter: blur(10px);
  /* Safari 支持 */
}

/* 进入动画（可选） */
/* .button_shrink_down-enter-from {
  opacity: 0;
  transform: translate(-50%, 0%) scaleY(0.6);
}

.button_shrink_down-enter-to {
  opacity: 1;
  transform: translate(-50%, 0%) scaleY(1);
}

.button_shrink_down-enter-active {
  transition: all 1s ease;
} */

/* 离开动画：向下收缩并缩小 */
.button_shrink_down-leave-from {
  opacity: 1;
  transform: translate(-50%, 0%) scaleY(1);
}

.button_shrink_down-leave-to {
  opacity: 0;
  transform: translate(-50%, 100%) scaleY(0.3);
}

.button_shrink_down-leave-active {
  transition: all 1.5s ease;
}

/* lang动画 */

.lang_animation {
  transform: translate(-50%, -30px);
  width: 340px;
  background-color: #121e3648;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}
</style>
